import { InputNumber as AntdInputNumber } from 'antd';
import styled from 'styled-components';

export const Container = styled.div({
  position: 'relative',

  display: 'flex',
  alignItems: 'center',

  marginBlockStart: '30rem',
});

export const Label = styled.p(({ theme }) => ({
  position: 'absolute',
  insetBlockStart: '-20rem',
  insetInlineStart: 0,

  margin: 0,

  fontSize: theme.typography.size12,
  color: theme.palette.sonicSilver,
}));

export const InputNumber = styled(AntdInputNumber<number>)({
  width: '50rem',
  marginInlineEnd: '10rem',
});

export const LimitsWarning = styled.p(({ theme }) => ({
  fontSize: theme.typography.size12,
  color: theme.palette.cadmiumRed,

  padding: 0,
  margin: 0,
  marginBlockStart: '10rem',
}));

const infoIconSize = '20rem';
const infoBtnPadding = '5rem';

export const InfoBtn = styled.button(({ theme }) => ({
  backgroundColor: 'transparent',
  height: `calc(${infoBtnPadding} + ${infoIconSize})`,
  borderRadius: '10rem',
  padding: infoBtnPadding,
  border: 'none',
  marginInlineStart: '10rem',

  color: theme.palette.coolBlack,
  fontSize: infoIconSize,

  cursor: 'pointer',
}));
